var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"observe-visibility",rawName:"v-observe-visibility",value:({
       callback: _vm.onVisible,
       intersection:{
         rootMargin: '0px -40% 0px -40%',
       }
}),expression:"{\n       callback: onVisible,\n       intersection:{\n         rootMargin: '0px -40% 0px -40%',\n       }\n}"}]},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }